import React, { Component, Fragment } from 'react'
import { css } from 'aphrodite';
import { SEStyles } from './SEStyles';
import { Tooltip } from '@material-ui/core';
import Accordion from '@material-ui/core/ExpansionPanel';
import AccordionSummary from '@material-ui/core/ExpansionPanelSummary';
import AccordionDetails from '@material-ui/core/ExpansionPanelDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import moment from 'moment-timezone'

import { Helper } from '../../helpers/Helper';
import { AppHelper } from '../../../helpers/AppHelper';
import { CustomSEStyles } from '../../../styles/CustomStyles';
import { AppConfig } from '../../../AppConfig';
import { AppButton } from '../AppButton';
import { UiHelper } from '../../helpers/UiHelper';

export class SubEntityCard extends Component {
  constructor(props) {
    super(props)
    this.fields = JSON.parse(JSON.stringify(this.props.formDefinition.steps[0].fields || []))
    this.tooltipFields = this.props.formDefinition.tooltipFields
    this.isMobileView = Helper.isMobileView()
  }

  render() {
    const fields = this.generateFields()
    const mainFields = [];
    const accountsFields = [];
    const advancedFields = [];
    if(this.props.advancedView) {
      this.classifyFields(fields, mainFields, accountsFields, advancedFields)
    }

    const showHeading = !this.props.hideTitle
    const showAccounts = this.props.advancedView && accountsFields.length > 0
    const showAdvanced = this.props.advancedView && advancedFields.length > 0
    const showAccountsDivider = this.props.showAdvancedDivider
      && showAccounts
      && mainFields.some(field => this.isValidField(field))
    const showAdvancedDivider = this.props.showAdvancedDivider
      && showAdvanced
      && (mainFields.some(field => this.isValidField(field)) || showAccounts)

    return (
      <div className={css(Styles.container, this.props.embedded && Styles.embeddedContainer)}>
        {showHeading && (
          <div className={css(Styles.heading)}>
            <div className={css(Styles.headingContent)}>
              {!this.props.hideTitle && <h2 className={css(Styles.stepFormTitle)}>{this.props.title}</h2>}
              {!this.props.noEdit &&
                <AppButton
                  onClick={() => this.props.openModalForEdit(this.props.item)}
                  buttonText={'Edit'}
                  buttonStyle={Styles.editButton}
                  buttonTextStyle={Styles.buttonText} />
              }
            </div>
          </div>
        )}
        <div className={css(Styles.content, this.props.renderFieldsRowwise && Styles.contentForRow, this.props.embedded && Styles.embeddedContent)}>
          {this.props.advancedView ? this.generateContent(mainFields) : this.generateContent(fields)}
        </div>
        {showAccountsDivider && <div className={css(Styles.advancedDivider)} />}
        {showAccounts && this.generateCollapsibleContent(accountsFields, Helper.getString('accounts') || 'Accounts')}
        {showAdvancedDivider && <div className={css(Styles.advancedDivider)} />}
        {showAdvanced && this.generateCollapsibleContent(advancedFields, Helper.getString('advanced') || 'Advanced')}
      </div>
    )
  }

  labelDisplay(item, fields) {
    return (<div className={css(Styles.fieldActionsContainer)}>
      <p className={css(Styles.label)}>{item.label}</p>
      {this.props.displayFieldActions && this.props.displayFieldActions(item, fields)}
    </div>)
  }

  valueDisplay(item) {
    // const valueMultiDisplayStyle = [Styles.value, Styles.valueDisplayMultiline]
    // const valueDisplayStyle = fields.length === 1 ? [Styles.value, Styles.valueDisplayMultiline] : Styles.value
    const valueMultiDisplayStyle = [Styles.value]
    const valueDisplayStyle = [Styles.value]

    const value = item.valueDisplay || item.resolvedValue || item.value

    if (item.type === 'rich_text') {
      return Helper.ellipsis(AppHelper.infoTextHelper(value))
    }

    if (item.html) {
      return <div className={css(Styles.valueContainer)}>
        <p className={css(Styles.value)} dangerouslySetInnerHTML={{ __html: value }} />
      </div>
    }
    if (item.multiline) {
      return <div className={css(Styles.valueContainer)}><p className={css(valueMultiDisplayStyle)}>{value}</p></div>
    }
    if (item.subType === 'image' && item.link) {
      return <div className={css(Styles.imageContainer)}><img src={item.link} className={css(Styles.imageContent)} /></div>
    }
    if (item.subType === 'document' && item.link) {
      return <div className={css(Styles.valueContainer)}><span><a href={item.link} target='_blank' className={css([valueDisplayStyle, Styles.link, Styles.openFileText])}>{Helper.getString('openFile')}</a></span></div>
    }
    if (item.subType === 'colour' && value) {
      return <div className={css(Styles.colourPickerContainer)} style={{ backgroundColor: value }}>{UiHelper.renderTransparentTileBycolorCode(value)}</div>
    }
    if(item.subType === 'hyperlink') {
      if(item.id && value && Array.isArray(this.tooltipFields) && this.tooltipFields.includes(item.id)) {
        return(<div className={css(Styles.valueContainer)}>
          <Tooltip title={<span className={css(Styles.tooltip)}>{value}</span>}  placement='top-start' classes={{ popper: css(Styles.tooltip) }}>
            <a href={Helper.toExternalHref(value)} target='_blank' rel='noopener noreferrer' className={css([Styles.value, Styles.hyperlink])}>{value}</a>
          </Tooltip>
        </div>)
      } else {
        return <div className={css(Styles.valueContainer)}>
          { value ?
            <a href={Helper.toExternalHref(value)} target='_blank' rel='noopener noreferrer' className={css([Styles.value, Styles.hyperlink])}>{value}</a>
            : <p className={css(valueDisplayStyle)}>{'[Not set]'}</p>
          }
        </div>
      }
    }
    else {
      if(item.id && value && Array.isArray(this.tooltipFields) && this.tooltipFields.includes(item.id)) {
        return <div className={css(Styles.valueContainer)}>
          <Tooltip title={<span className={css(Styles.tooltip)}>{value}</span>} placement='top-start' classes={{ popper: css(Styles.tooltip) }}>
            <p className={css(valueDisplayStyle)}>{value}</p>
          </Tooltip>
        </div>
      }
      return <div className={css(Styles.valueContainer)}><p className={css(valueDisplayStyle)}>{value || '[Not set]'}</p></div>
    }

  }
  isValidField(field) {
    if(field.hidden) {
      return false
    }
    if(this.isMobileView || this.props.embedded) {
      if (field.value == null || field.value === '' || (Array.isArray(field.value) && field.value.length === 0)) {
        return false
      }
    }
    return true
  }

  generateFields() {
    const fields = []
    for (const current of this.fields) {
      const field = {
        id: current.key,
        label: current.label,
        value: this.props.item[current.key],
        advanced: current.advanced,
        accounts: current.accounts,
      }
      if (field.value && current.valueDisplayScale) {
        field.value = (field.value / current.valueDisplayScale).toFixed(2)
      }
      if (current.html) {
        field.html = true
      }
      if (current.multiline) {
        field.multiline = true
      }
      if (current.imageUpload && current.linkName) { //retained for backward compatibility
        field.subType = 'image'
        field.link = this.props.item[current.linkName]
      }
      if (current.subType === 'image' && current.linkName) {
        field.subType = 'image'
        field.link = this.props.item[current.linkName]
      }
      if (current.documentUpload && current.linkName) { //retained for backward compatibility
        field.subType = 'document'
        field.link = this.props.item[current.linkName]
      }
      if (current.subType === 'document' && current.linkName) {
        field.subType = 'document'
        field.link = this.props.item[current.linkName]
      }
      if (current.colourPicker) { //retained for backward compatibility
        field.subType = 'colour'
      }
      if (current.subType === 'colour') {
        field.subType = 'colour'
      }
      if (current.subType === 'hyperlink') {
        field.subType = 'hyperlink'
      }
      if(current.hidden) {
        field.hidden = true
      }
      if(current.options) {
        field.options = current.options
      }
      switch (current.type) {
      case 'edit_text':
        break
      case 'rich_text':
        field.type = 'rich_text'
        //field.valueDisplay = 'YES'
        break
      case 'radio':
      case 'check_box':
      case 'select':
        //console.log('radio/check_box/select:', field, current)
        if (field.value && current.options) {
          const optionsByKey = {}
          let valuesToResolve = field.value
          if (!Array.isArray(valuesToResolve)) {
            valuesToResolve = [valuesToResolve]
          }
          valuesToResolve.forEach((val)=> {
            if(!current.options.some(obj => obj.key === val)) {
              current.options.push({ key: val, label: val });
            }
          })
          current.options.forEach(i => optionsByKey[i.key] = i)
          const resolvedValues = []
          valuesToResolve.forEach(i => optionsByKey[i] ? resolvedValues.push({text: optionsByKey[i].text || optionsByKey[i].label || 'UNK', href: optionsByKey[i].href || '', openInNewTab: optionsByKey[i].openInNewTab || false }) : {text: 'UNK', href: '', openInNewTab: false})
          if(current && current.showOptionsChips) {
            field.resolvedValue = `<div class="${css(Styles.optionsChipsContainer)}">${resolvedValues.map(resolvedVal => resolvedVal.href ? `<a href="${resolvedVal.href}" target="${resolvedVal.openInNewTab ? '_blank' : '_self'}" class="${css(Styles.optionsChip)}">${resolvedVal.text}</a>` : `<span class="${ css(Styles.optionsChip)}">${resolvedVal.text}</span>`).join('')}</div>`
          } else {
            field.resolvedValue = resolvedValues.map(resolvedVal => resolvedVal.href ? `<a href=${resolvedVal.href} target=${(resolvedVal && resolvedVal.openInNewTab) ? '_blank' : '_self'} style="text-decoration:none; color:#0246e5">${resolvedVal.text}</a>` : resolvedVal.text).join(', ')
          }
          field.html = true
        }
        break
      case 'date_yyyymmdd':
        field.resolvedValue = field.value ? moment(field.value).format('DD-MMM-YYYY') : ''
        break
      case 'dateTime':
        field.resolvedValue = field.value ? Helper.formatTimestamp(field.value) : ''
        break
      case 'duration':
        field.resolvedValue = field.value || field.value === 0 || field.value === '0' ? Helper.formatDuration(field.value) : ''
        break
      default:
        continue
      }
      if (!current.placement) {
        current.placement = 'left' // default
      }
      if (!(current.key in this.props.item) && !this.props.showFieldWithNoValueInitially) {
        continue
      }
      if (current.placement === 'left') {
        fields.push(field)
      } else if (current.placement === 'right') {
        fields.push(field)
      }
    }

    return fields
  }

  classifyFields(fields, mainFields, accountsFields, advancedFields) {
    for (const field of fields) {
      if (field.accounts) {
        accountsFields.push(field);
      } else if(field.advanced) {
        advancedFields.push(field);
      } else {
        mainFields.push(field);
      }
    }
  }

  generateContent(fields) {
    return(<>
    {fields.filter((field)=>this.isValidField(field)).map((item, index) => {
      return (
        <Fragment>
          <div key={item.label} className={this.props.renderFieldsRowwise ? css([Styles.labelContainer, Styles.labelContainerForRow]) : css(Styles.labelContainer)}>
            {this.labelDisplay(item, fields)}
            {this.valueDisplay(item)}
          </div>
          {this.props.renderFieldsRowwise && index % 2 === 0 && <div className={css(Styles.dividerForRow)} />}
        </Fragment>
      )
    })}
    </>)
  }

  generateCollapsibleContent(sectionFields, title) {
    return( <div className={css(Styles.content, Styles.accordionContainer, this.props.showAdvancedDivider && Styles.accordionContainerWithDivider, this.props.embedded && Styles.embeddedContent)}>
      <Accordion
        elevation={0}
        className={css(Styles.accordion)}
        defaultExpanded={!!this.props.advancedOpenByDefault}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon className={css(Styles.accordionIcon)}/>}
          classes={{ expandIcon: css(Styles.accordionExpandIcon) }}
          className={css(Styles.accordionSummary)}
        >
          <Typography className={css(Styles.advancedTitle)}>{title}</Typography>
        </AccordionSummary>
        <AccordionDetails className={this.props.renderFieldsRowwise ? css([Styles.content, Styles.contentForRow, Styles.accordionDetails, this.props.embedded && Styles.embeddedContent]) : css(Styles.content, this.props.embedded && Styles.embeddedContent)}>
          {this.generateContent(sectionFields)}
        </AccordionDetails>
      </Accordion>
    </div>)
  }

  generateAdvancedContent(advancedFields) {
    return this.generateCollapsibleContent(advancedFields, Helper.getString('advanced') || 'Advanced')
  }
}

const Styles = AppConfig.CUSTOM_STYLE ? CustomSEStyles : SEStyles
